import { render, staticRenderFns } from "./scrollText.vue?vue&type=template&id=e77da9b8&scoped=true&"
import script from "./scrollText.vue?vue&type=script&lang=js&"
export * from "./scrollText.vue?vue&type=script&lang=js&"
import style0 from "./scrollText.vue?vue&type=style&index=0&id=e77da9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77da9b8",
  null
  
)

export default component.exports